<template>
  <div
    
    class="support-ticket"
    @click="onTicketClick(current)"
  >
    <div class="st-meta">
      <i class="os-icon os-icon-ui-09"></i>
      </div>
    <div class="st-body">
      <div class="ticket-content">
        <div class="badge ticket-title">
          Posición:
          <span class="badge alert-success">{{current.nombre}}</span>
        </div>
        <div>
          <div class="badge ticket-title">
          Barra:
          <span class="badge alert-info">{{ current.codigo_barra }}</span>
        </div>
        </div>
        <div class="ticket-description">
          <span class="badge">Tienda:</span>
          <span class="badge text-success">{{ current.tienda }}</span>
          <br />
          <span class="badge">Tipo:</span>
          <span class="badge text-success">{{ current.tipo_posicion }}</span>
          <br />
          <span class="badge">Bodega:</span>
          <span class="badge text-success">{{ current.bodega_id }}</span>
          <br />
          <span class="badge">Sección:</span>
          <span class="badge text-success">{{ current.seccion_id }}</span>
          <br />
          <span class="badge">Rack:</span>
          <span class="badge text-success">{{ current.rack_id }}</span>
          <br />
        </div>
      </div>
    </div>
    <div class="st-foot"></div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  props: {
    current: {
      type: Object,
    },
  },
  mounted() {},
  methods: {
    truncate(text, length, suffix) {
      if (text === undefined || text === null || text == "") {
        return "";
      }
      return text.substring(0, length) + suffix;
    },
    onTicketClick(current) {
      this.$emit("onTicketClick", current);
    },
  },
};
</script>
